/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { GfsSevenKeyField } from '../gfs-seven-key-field.model';

export class SegmentReport {
  brandfamID: number;
  brandfam: string;
  gfsSevenKeyField: GfsSevenKeyField;
  globalSegment: string;
  propSegment: string;
}
